import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 50px 0 90px;
`;
